import {Component, OnInit} from "@angular/core";
import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  FileBlobService,
  ProjectService,
  UserService
} from "../../_services";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginHelper, Role, StringsHelper} from "../../helpers";
import {User} from "../../_models";
import {LogService} from "../../_services/log.service";
import {Audit} from "../../_models/audit";
import {AuditItem} from "../../_models/auditItem";
import {AuditService} from "../../_services/audit.service";
import {Constants} from "../../helpers/constants";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {SelectAuditTemplateComponent} from "../selectAuditTemplate/select-audit-template.component";

@Component({
    standalone: false,
  selector: "audit",
  templateUrl: 'audit.component.html',
  styleUrls: ['./audit.component.scss'],
})
export class AuditComponent implements OnInit {
  pageTitle: string;
  collapsed: boolean = false;
  audits: Audit[];
  auditId: number;
  auditItems: AuditItem[];
  selectedAudit: Audit;
  groupedAuditItems: any;
  displayDialog: boolean = false;
  users: User[];
  isMaster = false;
  isAssessor = true;
  subTabs = [
    {name: 'Artifacts & Evidence', tab: 0},
    {name: 'Policy & Procedures', tab: 1},
    {name: 'Mgmt Checklist', tab: 2},
    {name: 'ConMon Checklist', tab: 3},
  ];

  prepCols : any[] = [
    {'field': 'externalId', 'header': 'ID', width: '50px'},
    {'field': 'name', 'header': 'Item', width: '40%'},
    {'field': 'recommendedOwner', 'header': 'Owner', width: '40%'},
    {'field': 'dueDate', 'header': 'Due Date', width: '150px'}
  ];

  followCols : any[] = [
    {'field': 'externalId', 'header': 'ID', width: '50px'},
    {'field': 'type', 'header': 'Type', width: '40%'},
    {'field': 'name', 'header': 'Description', width: '40%'},
    {'field': 'attachmentIds', 'header': 'Attachments', width: '40%'},
    {'field': 'requestorId', 'header': 'Requestor', width: '40%'},
    {'field': 'ownerId', 'header': 'Owner', width: '40%'},
    {'field': 'dueDate', 'header': 'Date', width: '150px'},
    {'field': 'parentId', 'header': 'Assessor Finding ID', width: '40%'},
    {'field': 'created', 'header': 'Created', width: '40%'},
  ];

  assessorCols : any[] = [
    {'field': 'externalId', 'header': 'ID', width: '50px'},
    {'field': 'type', 'header': 'Type', width: '40%'},
    {'field': 'name', 'header': 'Item', width: '40%'},
    {'field': 'attachmentIds', 'header': 'Attachments', width: '40%'},
    {'field': 'assessorId', 'header': 'Assessor', width: '40%'},
    {'field': 'dueDate', 'header': 'Target Due Date', width: '40%'},
    {'field': 'resolved', 'header': 'Status', width: '40%'},
    {'field': 'created', 'header': 'Created', width: '150px'},
  ];
  prioritizedCols : any[] = [
    {'field': 'externalId', 'header': 'ID', width: '50px'},
    {'field': 'type', 'header': 'Type', width: '40%'},
    {'field': 'name', 'header': 'Item', width: '40%'},
    {'field': 'attachmentIds', 'header': 'Attachments', width: '40%'},
    {'field': 'assessorId', 'header': 'Owner', width: '40%'},
    {'field': 'dueDate', 'header': 'Target Due Date', width: '40%'},
    {'field': 'resolved', 'header': 'Status', width: '40%'},
    {'field': 'created', 'header': 'Created', width: '150px'},
  ];
  api = window.location.origin;
  tenantName: string;
  token: string;
  constants = Constants;

  constructor(
    public dialog: MatDialog,
    public logService: LogService,
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public auditService: AuditService,
    public clientProfileService: ClientProfileService,
    public userService: UserService,
    public alertService: AlertService,
    public fileBlobService: FileBlobService) {
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['Audit'] || 'Audits');
  }

  ngOnInit() {
    this.tenantName = LoginHelper.getTenantName();
    if (this.tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.token = LoginHelper.getFileToken();
    this.isMaster = this.tenantName == Constants.RiskSpongeMaster;
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.isAssessor = (currentUser.role & Role.Assessor) != 0;
    this.route.params.subscribe(p => {
      this.auditId = p['auditId'];
      this.loadAuditItems(this.auditId);
      this.loadAudits()
    });
    this.loadAudits();
    this.userService.getActiveShort().subscribe(u => this.users = u);
  }

  loadAudits() {
    this.auditService.getAllAudits().subscribe(r => {
      this.audits = r;
      this.selectedAudit = this.audits.find(t => t.auditId == this.auditId)
      this.groupedAuditItems = {};
      for (let i = 0; i < 7; i++) {
        this.groupedAuditItems[i] = (this.selectedAudit.auditItems || []).filter(t => t.tab == i);
      }
    });
  }

  loadAuditItems(id) {
    this.loadAudits();
    /*    this.auditService.getAuditItems(id).subscribe(r => {
          this.auditItems = r;
          this.groupedAuditItems = {};
          for (var i = 0; i < 6; i++) {
            this.groupedAuditItems[i] = (this.selectedAudit.auditItems || []).filter(t => t.tab == i);
          }
        });*/
  }

  createAudit() {
    if (this.isMaster)
    {
      this.auditService.addAudit(0,{name: 'Audit'}).subscribe(r => this.router.navigate(['/audit', r]))
    }
    else
    {
      let config: MatDialogConfig = {
        panelClass: 'custom-overlay-pane-class',
        width: '400px',
        height: '200px',
        data: {
        }
      };


      const dialogRef = this.dialog.open(SelectAuditTemplateComponent, config);

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result !== undefined) {
          this.auditService.addAudit(result,{name: 'Audit'}).subscribe(r => this.router.navigate(['/audit', r]))
        }
      });
    }
  }

  saveAuditItem(item) {
    if (item.auditItemId) {
      this.auditService.updateAuditItem(item).subscribe(() => {
        this.loadAuditItems(this.auditId);
      });
    } else {
      this.auditService.addAuditItem(item).subscribe(() => {
        this.loadAuditItems(this.auditId);
      });
    }
  }

  closeDialog() {
    this.displayDialog = false;
  }

  deleteAuditItem(auditItem) {
    this.auditService.deleteAuditItem(auditItem.auditItemId).subscribe(() => this.loadAuditItems(this.auditId));
  }

  str(txt) {
    return (txt || '').replace(/<.*?>/g, '');
  }

  saveAudit() {
    this.auditService.updateAudit(this.selectedAudit).subscribe(() => this.loadAudits());
  }

  deleteAudit() {
    this.auditService.deleteAudit(this.auditId).subscribe(() => this.loadAudits());
  }

  removeAuditItem(item) {
    this.auditService.deleteAuditItem(item.auditItemId).subscribe(() => this.loadAuditItems(this.auditId));
  }

  getFullName(user: User): string {
    return StringsHelper.getFullName(user);
  }

  getFullNameById(id: number) {
    if (this.users) {
      return this.getFullName(this.users.find(u => u.userId == id));
    }
    return '';
  }

  public addAttachment(event, item) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.auditService.uploadAttachment(item.auditItemId, file).subscribe(
        (names) => {
          const errorMessage = 'The control items were uploaded.';
          item.attachments = item.files || [];
          item.attachments.push(names);
          this.alertService.success(errorMessage);
        },
        (error) => {
          const errorMessage = 'An error occurred while upload audit item attachment.';
          this.alertService.error(errorMessage);
        });
    }
  }

  up(item) {
    const i = this.groupedAuditItems[item.tab].indexOf(item);
    this.groupedAuditItems[item.tab][i] = this.groupedAuditItems[item.tab][i - 1];
    this.groupedAuditItems[item.tab][i - 1] = item;
    this.auditService.setAuditItemOrder(this.groupedAuditItems[item.tab].map(p => p.auditItemId)).subscribe(() => {
      this.loadAuditItems(this.auditId);
    })
  }

  down(item) {
    const i = this.groupedAuditItems[item.tab].indexOf(item);
    this.groupedAuditItems[item.tab][i] = this.groupedAuditItems[item.tab][i + 1];
    this.groupedAuditItems[item.tab][i + 1] = item;
    this.auditService.setAuditItemOrder(this.groupedAuditItems[item.tab].map(p => p.auditItemId)).subscribe(() => {
      this.loadAuditItems(this.auditId);
    })
  }

  deleteAttachment(attachmentId) {
    this.auditService.deleteAttachment(attachmentId).subscribe(c => this.loadAudits());
  }

  setType(item, value) {
    item.type = value;
  }

  protected readonly encodeURIComponent = encodeURIComponent;
}

